import React from 'react'
import styles from './Privacy.module.css'

export default function Privacy() {
  return (
    <main className={styles.main}>
      <div className={styles.container}>
        <h1 className={styles.title}>Privacy Policy</h1>
        <div className={styles.content}>
          <p>
            VerifyLink is built on a privacy-first architecture. This policy explains how we handle
            your data.
          </p>
          <h2>No Server-Side Decryption</h2>
          <p>
            All files are encrypted in your browser using the Web Crypto API with AES-256-GCM. The
            encryption key is stored only in the URL fragment, which is never sent to our servers. We
            cannot decrypt your files under any circumstances.
          </p>
          <h2>Automatic Deletion</h2>
          <p>
            Uploaded files are stored for a maximum of 15 minutes. After this period, they are
            permanently deleted by an automated cleanup process. We do not retain backups.
          </p>
          <h2>Peer-to-Peer Phone Control</h2>
          <p>
            When you connect your phone to your laptop, video and control signals are sent
            peer-to-peer via WebRTC after initial signaling. Your phone screen never passes through
            our servers.
          </p>
          <h2>No Tracking</h2>
          <p>
            We do not use analytics, tracking cookies, or third-party services that process your
            file content.
          </p>
          <h2>Contact</h2>
          <p>
            If you have questions about this privacy policy, please contact us through our website.
          </p>
        </div>
      </div>
    </main>
  )
}
